import { render, staticRenderFns } from "./resetAccount.vue?vue&type=template&id=921662d4&scoped=true&lang=html&"
import script from "./resetAccount.vue?vue&type=script&lang=js&"
export * from "./resetAccount.vue?vue&type=script&lang=js&"
import style0 from "./resetAccount.vue?vue&type=style&index=0&id=921662d4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921662d4",
  null
  
)

component.options.__file = "resetAccount.vue"
export default component.exports